import type { AuthResponseV2, LoginRequestInterface, RefreshRequestInterface } from '@core/api/Interface'
import type { UserHydraItem } from './user/user.interface'
import { StorageSerializers } from '@vueuse/core'

export const useAuthStore = createGlobalState(
  () => {
    const { authenticate } = createAuthenticatePlugin({
      path: AuthPath.JSON_LOGIN_V2,
      axios: api,
      onAuthenticateSuccess,
    })
    const user = ref<UserHydraItem | null>(null)
    const hash = ref<string | null>(null)
    const token = useStorage<string | null>('token', null, sessionStorage, {
      serializer: StorageSerializers.string,
    })
    const hasHash = computed(() => {
      return hash.value !== null
    })

    const refreshToken = useStorage<string | null>(
      'refresh_token',
      null,
      localStorage,
      { serializer: StorageSerializers.string },
    )

    const isAuthenticated = computed(() => {
      return token.value !== null
    })

    const hasToken = computed(() => {
      return token.value !== null
    })
    // getters
    const tokenPayload = computed(() => {
      if (token.value === null)
        return null

      const base64Url = token.value.split('.')[1]
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => {
            return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`
          })
          .join(''),
      )

      return JSON.parse(jsonPayload)
    })

    function setUser(usr: UserHydraItem) {
      user.value = usr
    }

    function reset() {
      token.value = null
      refreshToken.value = null
      hash.value = ''
      user.value = null
      // useAppSubscriptions().reset()
      // useApps().reset()
    }

    async function validateHash(hasParam: string) {
      if (!hasParam)
        throw new Error('No hash provided')

      await authenticate({ hash: hasParam })
    }

    function login(data: AuthResponseV2, input: LoginRequestInterface | RefreshRequestInterface) {
      token.value = data.token
      refreshToken.value = data.refresh_token
      if ('hash' in input) {
        hash.value = input.hash
      }
    }

    const isAdmin = computed(() => {
      return user.value?.roles?.includes(UserRole.ADMIN)
    })

    return {
      login,
      token,
      user,
      setUser,
      validateHash,
      refreshToken,
      isAdmin,
      isAuthenticated,
      hasToken,
      tokenPayload,
      reset,
      hash,
      hasHash,
    }
  },
)
